export default __webpack_public_path__ + "static/media/grafema_2ndliferesin_15.8cc3b36c.jpg";